import { Component, OnInit, Input, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import _moment from 'proxies/dayjs';
const moment = _moment;

@Component({
    selector: 'kx-month-picker',
    templateUrl: './ng-month-picker.component.html',
    styleUrls: ['./ng-month-picker.component.css'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: NgMonthPickerComponent,
            multi: true
        }],
    standalone: false
})

export class NgMonthPickerComponent implements OnInit, ControlValueAccessor {

  @Input() formControlName: any = "";
  @Output('change') onChanged: EventEmitter<Object> = new EventEmitter();
  @Input() config: any;
  @Input() resource: any;
  @Input() placeholder: any = ""
  @Input() id: any;
  @Input() disabled: boolean = false
  @Input() inputClass = 'form-control';
  @Input() displayFormat = 'MM/YYYY';
  @Input() valueFormat = 'YYYY-MM';
  @Input() disablePreviousYearMonth: boolean = false;
  @Input() disableNextYearMonth: boolean = false;
  @Input() value: any = null
  // @Input() showIcon = true;
  @Input() isInvalid = false;
  isOpen = false;
  months: any[] = [];
  selectedYear: any;
  selectedMonth: any;
  displayValue: any;
  controlValue: any;
  onChange: any = () => { };
  onTouch: any = () => { };
  currentYear: any = moment().format('YYYY');
  currentMonth: any = moment().format('MM');

  constructor(
    private cdr: ChangeDetectorRef
  ) { }
  ngOnInit() {
    // debugger;
    // console.log("formControlName", this.config);
    if (this.config.form.controls[this.formControlName].value == "")
      this.config.form.controls[this.formControlName].patchValue(null)
    this.selectedYear = parseInt(moment().format('YYYY'), 10);
    this.generateMonths();
  }

  writeValue(value) {
    if (value) {
      this.displayValue = moment(value).format(this.displayFormat);
      this.controlValue = moment(value).format(this.valueFormat);
      this.setSelectedYearMonth();
      this.onChange(this.controlValue);
      this.onTouch(this.controlValue);
      this.setValue(this.displayValue, value);
    } else {
      this.displayValue = ""//moment(value).format(this.displayFormat);
      this.controlValue = ""//moment(value).format(this.valueFormat); 
      this.onChange(null);
      this.onTouch(null);
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  // get value() {
  //   return null;
  // }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  selectMonth(selectedMonth) {
    if (this.disablePreviousYearMonth) {
      if ((selectedMonth < this.currentMonth) && (this.selectedYear <= this.currentYear))
        return
    }
    if (this.disableNextYearMonth) {
      if ((selectedMonth > this.currentMonth) && (this.selectedYear >= this.currentYear))
        return
    }
    this.selectedMonth = selectedMonth;
    this.setValue(selectedMonth);
    this.isOpen = false;
  }

  setValue(selectedMonth, data?) {
    if (selectedMonth) {
      if (moment(`${this.selectedYear}-${this.selectedMonth}`).format(this.displayFormat) == "Invalid date") {
        this.displayValue = null
        return
      } else {
        if (this.disablePreviousYearMonth) {
          if(this.selectedYear < this.currentYear){
            this.displayValue = null;
            this.selectedYear = this.currentYear;
                return
          }
          if ((selectedMonth < this.currentMonth) && (this.selectedYear <= this.currentYear)) {
            this.displayValue = null
            return
          } else {
            this.displayValue = moment(`${this.selectedYear}-${this.selectedMonth}`).format(this.displayFormat);
            this.controlValue = moment(`${this.selectedYear}-${this.selectedMonth}`).format(this.valueFormat);
            var value
            if (data)
              value = data
            else
              value = moment(`${this.selectedYear}-${this.selectedMonth}`).endOf('month').valueOf();
            if(isNaN(value)){
              this.displayValue = null
              return
            }  
            this.setSelectedYearMonth();
            this.onChange(value);
            this.onTouch(value);
            this.onChanged.emit(value);
          }
        }
        if (this.disableNextYearMonth) {
          if ((selectedMonth >= this.currentMonth) && (this.selectedYear > this.currentYear)) {
            this.displayValue = null
            this.selectedYear = this.currentYear;
            return
          } else {
            this.displayValue = moment(`${this.selectedYear}-${this.selectedMonth}`).format(this.displayFormat);
            this.controlValue = moment(`${this.selectedYear}-${this.selectedMonth}`).format(this.valueFormat);
            var value
            if (data)
              value = data
            else
              value = moment(`${this.selectedYear}-${this.selectedMonth}`).endOf('month').valueOf();
            this.setSelectedYearMonth();
            this.onChange(value);
            this.onTouch(value);
            this.onChanged.emit(value);
          }
        } else {
          this.displayValue = moment(`${this.selectedYear}-${this.selectedMonth}`).format(this.displayFormat);
          this.controlValue = moment(`${this.selectedYear}-${this.selectedMonth}`).format(this.valueFormat);
          const value = moment(`${this.selectedYear}-${this.selectedMonth}`).endOf('month').valueOf();
          this.setSelectedYearMonth();
          this.onChange(value);
          this.onTouch(value);
          this.onChanged.emit(value);
        }
      }
    }
  }

  selectDate(date: any, event: KeyboardEvent) {
    if (event.keyCode == 191) {
      this.displayValue = null
    }
    if (date) {
      if (date.length == 2) {
        this.displayValue = this.displayValue + "/"
      }
      if (date.length == 7) {
        this.selectedMonth = date.split("/")[0];
        this.selectedYear = date.split("/")[1];
        this.setValue(date.split("/")[0])
      }
      if (date.length > 7) {
        this.displayValue = null
      }
    }

  }

  onFocus() {
    this.onTouch(null);
  }
  toggle() {
    this.isOpen = !this.isOpen;
  }
  onClickOutside(event) {
    this.isOpen = false;
    this.cdr.detectChanges();
    this.setSelectedYearMonth();
  }

  setSelectedYearMonth() {
    if (this.controlValue) {
      // debugger;
      this.selectedYear = moment(this.controlValue).format('YYYY');
      this.selectedMonth = moment(this.controlValue).format('MM');
    }
  }
  incrementYear() {
    this.selectedYear++;
  }

  decrementYear() {
    this.selectedYear--;
  }
  generateMonths() {
    const months = moment.monthsShort().map((month, index) => {
      const item = {
        value: moment().month(index).format('MM'),
        name: month
      };
      return item;
    });
    this.splitMonths(months, 3);
  }

  splitMonths(months, part) {
    this.months = [];
    while (months.length > 0) {
      const splittedMonts = months.splice(months, part);
      this.months.push(splittedMonts);
    }
  }

  // inValid() {
  //   this.config.form.controls['expiryDate'].setErrors({ 'incorrect': true })
  // }


}
